import AdminApi from '../stylemix-vue-admin/plugins/api'

export default class CompanyPricesApi extends AdminApi {
  constructor(parameters) {
    super('company', parameters)
  }

  getTransferPricingForm(data) {
    this.setParameters(data)
    return this.submit('get', 'company/airport-pricing/form')
  }

  getTransferPricingIndex(data) {
    this.setParameters(data)
    return this.submit('get', 'company/airport-pricing/index')
  }

  deleteTransferPricing(data) {
    return this.submit('delete', `company/airport-pricing`, data)
  }

  deleteCityTaxiPricing(data) {
    return this.submit('delete', `company/city-taxi-pricing`, data)
  }

  getTransferPricing(data) {
    this.setParameters(data)
    return this.submit('get', 'company/airport-pricing')
  }

  updateTransferPricing(data) {
    return this.submit('post', 'company/airport-pricing', data)
  }

  approveTransferPricing(data) {
    return this.submit('post', 'company/airport-pricing/approve', data)
  }

  refuseTransferPricing(data) {
    return this.submit('post', 'company/airport-pricing/refuse', data)
  }

  getCityTaxiPricingForm(data) {
    this.setParameters(data)
    return this.submit('get', 'company/city-taxi-pricing/form', data)
  }

  getCityTaxiPricingIndex(data) {
    this.setParameters(data)
    return this.submit('get', 'company/city-taxi-pricing/index')
  }

  getCityTaxiPricing(data) {
    this.setParameters(data)
    return this.submit('get', 'company/city-taxi-pricing')
  }

  updateCityTaxiPricing(data) {
    return this.submit('post', 'company/city-taxi-pricing', data)
  }

  approveCityTaxiPricing(data) {
    return this.submit('post', 'company/city-taxi-pricing/approve', data)
  }

  refuseCityTaxiPricing(data) {
    return this.submit('post', 'company/city-taxi-pricing/refuse', data)
  }

  getCompanies() {
    return this.submit('get', 'company/city-taxi-pricing/companies')
  }

  getCompanyRelations(companyId, data) {
    this.setParameters(data)
    return this.submit('get', `companies/${companyId}/relations`)
  }

  getVehicles(data) {
    this.setParameters(data)
    return this.submit(
      'get',
      data?.where?.company_id
        ? `companies/${data.where.company_id}/vehicles`
        : 'company/vehicles'
    )
  }

  getAirports(data) {
    this.setParameters(data)
    return this.submit(
      'get',
      data?.where?.company_id
        ? `companies/${data.where.company_id}/airports`
        : 'company/airports'
    )
  }

  getDivisions(data) {
    this.setParameters(data)
    return this.submit(
      'get',
      data?.where?.company_id
        ? `companies/${data.where.company_id}/divisions`
        : 'company/divisions'
    )
  }
}
